(() => {
  if (window.__sssMerchandisingPriorityLoaded) return;
  window.__sssMerchandisingPriorityLoaded = true;

  const normalize = (value) => String(value || '').trim().toLowerCase();

  const getMediaRecord = (element) => {
    const img = element?.querySelector?.('img');
    const src = img?.currentSrc || img?.src || element?.dataset?.zoomUrl || '';
    if (!src) return null;

    const filename = decodeURIComponent(src.split('/').pop().split('?')[0]);
    const match = filename.match(/^(.+)-(01|02|03|05|06|07|ONFOOT)(?:_|\.|$)/i);
    if (!match) return null;

    let family = match[1].toUpperCase();
    if (family === 'BALDWIN-CAMP') family = 'BALDWIN-CAP';

    return { family, view: match[2].toUpperCase() };
  };

  const getColorSelector = (picker) => {
    const optionName = picker.dataset.sssInventoryPreferredOption;
    if (!optionName) return null;
    return Array.from(picker.querySelectorAll('[data-option]')).find(
      (selector) => normalize(selector.dataset.option) === normalize(optionName)
    ) || null;
  };

  const hasExplicitColorIntent = (picker) => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('variant')) return true;
    const optionName = normalize(picker.dataset.sssInventoryPreferredOption);
    return Array.from(params.keys()).some((key) => {
      const normalizedKey = normalize(key);
      return normalizedKey === optionName || normalizedKey.includes('color') || normalizedKey.includes('colour');
    });
  };

  const getListedSelectedValue = (selector) => selector?.querySelector('input.js-option:checked')?.value || '';
  const getDropdownSelectedValue = (selector) => {
    const customSelect = selector?.querySelector('custom-select');
    return customSelect?.selectedOption?.dataset?.value
      || customSelect?.querySelector('[aria-selected="true"]')?.dataset?.value
      || '';
  };
  const getSelectedColor = (selector) => {
    if (!selector) return '';
    return selector.dataset.selectorType === 'dropdown' ? getDropdownSelectedValue(selector) : getListedSelectedValue(selector);
  };

  const moveListedValueFirst = (selector, value) => {
    const wrapper = selector?.querySelector('.option-selector__btns');
    if (!wrapper || !value) return;
    const input = Array.from(wrapper.querySelectorAll('input.js-option')).find((item) => item.value === value);
    if (!input) return;
    const label = wrapper.querySelector(`label[for="${input.id}"]`);
    if (!label) return;
    wrapper.prepend(input, label);
  };

  const moveDropdownValueFirst = (selector, value) => {
    const list = selector?.querySelector('.custom-select__listbox');
    if (!list || !value) return;
    const option = Array.from(list.querySelectorAll('.custom-select__option')).find((item) => item.dataset.value === value);
    if (!option) return;
    const defaultOption = list.querySelector('[data-value=""]');
    if (defaultOption) defaultOption.after(option);
    else list.prepend(option);
  };

  const moveColorFirst = (selector, value) => {
    if (!selector || !value) return;
    if (selector.dataset.selectorType === 'dropdown') moveDropdownValueFirst(selector, value);
    else moveListedValueFirst(selector, value);
  };

  const selectColor = (selector, value) => {
    if (!selector || !value) return false;
    if (selector.dataset.selectorType === 'dropdown') {
      const customSelect = selector.querySelector('custom-select');
      const option = Array.from(selector.querySelectorAll('.custom-select__option')).find(
        (item) => item.dataset.value === value && !item.classList.contains('is-disabled')
      );
      if (!customSelect || !option || typeof customSelect.selectOption !== 'function') return false;
      customSelect.selectOption(option);
      return true;
    }
    const input = Array.from(selector.querySelectorAll('input.js-option')).find((item) => item.value === value && !item.disabled);
    if (!input) return false;
    if (input.checked) return true;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };

  const applyInventoryPriority = (picker) => {
    const selector = getColorSelector(picker);
    if (!selector) return;
    if (hasExplicitColorIntent(picker)) {
      moveColorFirst(selector, getSelectedColor(selector));
      return;
    }
    const preferredValue = picker.dataset.sssInventoryPreferredValue;
    if (!preferredValue) return;
    moveColorFirst(selector, preferredValue);
    if (getSelectedColor(selector) === preferredValue) return;
    const originalUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (selectColor(selector, preferredValue)) {
      requestAnimationFrame(() => {
        const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        if (currentUrl !== originalUrl) window.history.replaceState({}, '', originalUrl);
      });
    }
  };

  const getSelectedVariant = (picker) => {
    if (picker.variant) return picker.variant;
    const selectedOptions = typeof picker.getSelectedOptions === 'function' ? picker.getSelectedOptions() : [];
    return picker.data?.variants?.find(
      (variant) => variant.options.every((option, index) => option === selectedOptions[index])
    ) || null;
  };

  const getVariantFamily = (gallery, variant) => {
    const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
    if (!mediaId) return null;
    const source = Array.from(gallery.querySelectorAll('.main-image .slider__item')).find(
      (element) => String(element.dataset.mediaId) === String(mediaId)
    );
    return getMediaRecord(source)?.family || null;
  };

  const getHeroMediaId = (gallery, variant) => {
    const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
    if (!mediaId) return null;
    if (typeof gallery.getVariantPrimaryMediaId === 'function') return String(gallery.getVariantPrimaryMediaId(mediaId));
    return String(mediaId);
  };

  const reorderOnFootInList = (mediaList, family, heroMediaId) => {
    const items = Array.from(mediaList || []);
    if (!items.length) return false;
    const familyItems = items.map((element) => ({ element, record: getMediaRecord(element) }))
      .filter(({ record }) => record?.family === family);
    const onFoot = familyItems.find(({ record }) => record.view === 'ONFOOT')?.element;
    if (!onFoot) return false;
    const hero = items.find((element) => String(element.dataset?.mediaId) === String(heroMediaId))
      || familyItems.find(({ record }) => record.view === '05')?.element;
    if (!hero?.parentNode || onFoot.parentNode !== hero.parentNode) return false;
    onFoot.hidden = false;
    if (hero.nextElementSibling !== onFoot) hero.parentNode.insertBefore(onFoot, hero.nextElementSibling);
    return true;
  };

  const applyOnFootPriority = (picker) => {
    const gallery = picker.closest('.js-product')?.querySelector('media-gallery') || document.querySelector('media-gallery');
    if (!gallery) return;
    const variant = getSelectedVariant(picker);
    if (!variant) return;
    const family = getVariantFamily(gallery, variant);
    const heroMediaId = getHeroMediaId(gallery, variant);
    if (!family || !heroMediaId) return;
    const lists = Array.isArray(gallery.mediaLists)
      ? gallery.mediaLists
      : [
          gallery.querySelectorAll('.main-image .slider__item'),
          gallery.querySelectorAll('.thumbnail-list .slider__item'),
          gallery.querySelectorAll('.media-gallery-modal .slider__item')
        ];
    let changed = false;
    lists.forEach((list) => { if (reorderOnFootInList(list, family, heroMediaId)) changed = true; });
    if (changed) {
      gallery.mainMedia?.refresh?.();
      gallery.thumbs?.refresh?.();
      gallery.galleryModal?.refresh?.();
    }
  };

  const setupPicker = (picker) => {
    if (!picker || picker.dataset.sssMerchandisingReady === 'true') return;
    picker.dataset.sssMerchandisingReady = 'true';
    applyInventoryPriority(picker);
    requestAnimationFrame(() => applyOnFootPriority(picker));
  };

  const setupAll = (root = document) => {
    if (root.matches?.('variant-picker')) setupPicker(root);
    root.querySelectorAll?.('variant-picker').forEach(setupPicker);
  };

  const boot = () => setupAll(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('on:variant:change', (event) => {
    const picker = event.target?.matches?.('variant-picker') ? event.target : event.target?.closest?.('variant-picker');
    if (picker) requestAnimationFrame(() => applyOnFootPriority(picker));
  });

  document.addEventListener('on:quickbuy:after-open', (event) => setupAll(event.target || document));
})();
